import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import { setURI, save, setErrors } from './actions';
import { setMode as setGlobalMode, resetMode, MODE_CONCENTRATE, request } from '../containers/actions';
import tinyMCEConfig from '../utilities/tinymce_config';
import Content from './content';
import { Button } from 'rmwc';

export default class ContentManager extends React.Component {
    static contextTypes = {
        user: PropTypes.object,
        pending: PropTypes.number,
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            content: props.content.content,
            title: props.content.title,
            uri: props.content.uri,
            published: props.content.published,
        };
    }

    componentDidMount() {
        this.props.dispatch(setURI(this.props.uri, this.props.elementId));
    }

    componentWillReceiveProps(nextProps, nextSatate) {
        if (nextProps.uri !== this.props.uri)
            this.props.dispatch(setURI(nextProps.uri, nextProps.elementId));
        if (nextProps.content.content !== this.props.content.content)
            this.setState({ content: nextProps.content.content });
        if (nextProps.content.title !== this.props.content.title)
            this.setState({ title: nextProps.content.title });
        if (nextProps.content.uri !== this.props.content.uri)
            this.setState({ uri: nextProps.content.uri });
        if (nextProps.content.published !== this.props.content.published)
            this.setState({ published: nextProps.content.published });

    }

    async save() {
        // debugger;
        try {
            await this.props.dispatch(save(
                {
                    id: this.props.content.id,
                    title: this.state.title,
                    uri: this.state.uri,
                    content: this.state.content,
                    published: this.state.published,
                },
                this.props.elementId,
            ));
        }
        catch (error) {
            this.props.dispatch(setErrors(error, this.props.elementId));
        }
    }

    render() {
        return <div style={{
            marginTop: '.5em',
            margin: 'auto',
            transform: 'scale(' + Math.min(1, window.innerWidth / 1000) + ')',
            transformOrigin: 'top right 0px',
            display: 'block',
            width: window.innerWidth / Math.min(1, window.innerWidth / 1000),
            maxWidth: '1100px'
        }}>
            {this.context.user.hasPerm('content_manager.create') || this.props.content.published
                ? <Content
                    content={this.props.content.content}
                    title={this.state.title || '-'}
                    uri={this.state.uri}
                    published={this.props.content.published}
                    readonly={this?.context?.user?.hasPerm('content_manager.create') || this?.context?.user?.is_superuser ? false : true}
                    errors={this.props.errors}
                    actions={[{ label: window.gettext('Save'), action: this.save.bind(this), default: true }]}
                    titleLabel={window.gettext('Page Title')}
                    preview
                    tinymceConfig={{
                        ...tinyMCEConfig,
                        toolbar: [
                            ...tinyMCEConfig.toolbar.slice(0, -1),
                            tinyMCEConfig.toolbar.slice(-1)[0] + ' | map toggle_position toggle_size line effects store_item',
                        ],
                    }}
                    onFocusin={() => {
                        this.props.dispatch(setGlobalMode(MODE_CONCENTRATE));
                    }}
                    onFocusout={() => {
                        this.props.dispatch(resetMode());
                    }}
                    onChange={content => {
                        this.setState({ content });
                    }}
                    onTitleChange={title => {
                        this.setState({ title });
                    }}
                    onURIChange={uri => {
                        this.setState({ uri });
                    }}
                    onPublishedChange={published => {
                        this.setState({ published });
                    }}
                    onLinkClicked={event => {
                        let node = event.target;
                        while (node && !(node instanceof HTMLAnchorElement)) {
                            node = node.parentNode;
                        }
                        if (!node)
                            return;
                        let href = node.href || node.xlinkHref;
                        if (!href)
                            return;
                        if (href.baseVal)
                            href = href.baseVal;
                        let base = `${window.location.protocol}//${window.location.hostname}`;
                        if (window.location.port)
                            base += `:${window.location.port}`;
                        if (href.startsWith(base) || !_.includes(href, '://')) {
                            event.preventDefault();
                            this.props.dispatch(push(href.replace(new RegExp('^' + base), '')));
                        }
                    }}
                />
                : this.context.pending
                    ? null
                    : this.context.user.id ? <div style={{ fontSize: '2em', textAlign: 'center' }}>
                        <br />
                        <br />
                        <span style={{ fontSize: '3em' }}>
                            404
                        </span>
                        <br />
                        {window.gettext('Page not found!')}
                    </div> : <div className='primision-box' >
                        <p>
                            <br />
                            شما دسترسی لازم برای مشاهده این صفحه را ندارید
                            <br />
                            لطفا ابتدا به حساب خود وارد شوید.
                            <br />
                        </p>
                        <Button style={{ fontSize: '1.4rem', borderRadius: '5px', border: '1px solid' }} onClick={() => this.props.router.push('/?dialog=login')}>ورود</Button>
                    </div>
            }
        </div>;
    }
};
